import { SafeUrl } from '@angular/platform-browser';
import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import moment from 'moment-timezone';
import { DriverDocumentType } from './driver-document-type';
import { State } from './state';

/**
 * Verify this is deprecated
 *
 * @deprecated
 */
@inheritSerialization(AbstractModel)
export class DriverDocument extends AbstractModel {
  @autoserialize
  tncDriverProfileId: number;

  @autoserialize
  driverId: number;

  @autoserialize
  filename: string;

  @autoserializeAs(DriverDocumentType)
  documentType: DriverDocumentType;

  @autoserialize
  number: string;

  @autoserializeAs(Date)
  expirationDate: Date;

  @autoserializeAs(State)
  state: State;

  @autoserialize
  file: string | SafeUrl;

  @autoserialize
  mimeType: string;

  @autoserialize
  rejected: boolean;

  @autoserialize
  rejectionComments: string;

  @autoserialize
  active: boolean;

  @autoserialize
  approved: boolean;

  constructor() {
    super();
    this.mimeType = 'image/jpeg';
  }

  static OnSerialized(instance: DriverDocument, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.expirationDate)) {
      // Create UTC date
      instance.expirationDate = new Date(
        Date.UTC(instance.expirationDate.getFullYear(), instance.expirationDate.getMonth(), instance.expirationDate.getDate())
      );
      json.expirationDate = DateUtil.serializeDate(instance.expirationDate);
    }
  }

  static OnDeserialized(instance: DriverDocument, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['expirationDate'])) {
      // Adjust UTC date for local offset
      const parsedExpirationDate: Date = new Date(json['expirationDate']);
      instance.expirationDate = moment(parsedExpirationDate)
        .add(parsedExpirationDate.getTimezoneOffset(), 'minutes')
        .toDate();
    }
  }
}
